import { useModal } from "../../contexts/ModalContext";
import { useToast } from "../../contexts/ToastContext";
import { useEffect, useState } from "react";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";
import SmallLoading from "../../Componentes/Utils/SmallLoading";

import useApi from "../../hooks/useApi";
const AddCipa = ({ updateCipas }) => {
    const api = useApi();


    const { closeModal } = useModal();
    const { notifyError } = useToast();

    const [loading, setLoading] = useState(true);

    const [centrosCusto, setCentrosCusto] = useState([]);

    useEffect(() => {

        const getCentroCustos = async () => {
            setLoading(true);
            try {
                const { data } = await api.get("/Painel/API/GetObrasAtivas/")
                setCentrosCusto(data.map(obj => obj.OBRA))
            } catch (error) {
                console.log("Erro ao buscar centros de custo: ", error);
            } finally {
                setLoading(false);
            }
        }

        getCentroCustos();

    }, [])

    const [formValues, setFormValues] = useState({
        centroCusto: "",
        dataInicio: "",
        dataTermino: ""
    })

    const handleChange = (e, field) => {
        setFormValues({
            ...formValues,
            [field]: e.target.value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const { data } = await api.post("/Painel/API/Cipa/CreateCipa/", formValues, {
                withCredentials: true
            });
            console.log(data);
            await updateCipas?.();
            closeModal();
        } catch (error) {
            notifyError(error.response?.data?.message || "Erro ao criar CIPA.");
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="md" header={true} close={closeModal} >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="CENTRO CUSTO"
                            type="select"
                            options={centrosCusto}
                            changeFunc={(e) => handleChange(e, 'centroCusto')}
                            required
                        />
                        <FormComp
                            title="DATA INÍCIO"
                            type="datetime-local"
                            changeFunc={(e) => handleChange(e, 'dataInicio')}
                            required
                        />
                        <FormComp
                            title="DATA TERMINO"
                            type="datetime-local"
                            changeFunc={(e) => handleChange(e, 'dataTermino')}
                            required
                        />
                        <p style={{
                            fontSize: "12px",
                            color: "#777",
                            marginTop: "6px",
                            textAlign: "center"
                        }}>
                            Os horários são considerados no fuso de Brasília (UTC-3).
                        </p>
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
                {loading && (
                    <Overlay state={true} >
                        <Modal size="sm" >
                            <SmallLoading />
                        </Modal>
                    </Overlay>
                )}
            </Overlay>
        </>
    )
}

export default AddCipa;